<template>
<div class="container-fluid">
  <div class="row marketing">
    <div class="col-3">
      <h4 class="form-head">
        New Customer
      </h4>
      <form action="" name="cform1">
        <div class="form-group">
          <label for="gst">GST Number</label>

          <div class="input-group mb-3">
            <input type="text" class="form-control" placeholder="Enter GSTIN"                   v-model="c.gstin"
                   id="gst"
                   maxlength="15"
                   minlength="15"
                   required
            >
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" v-on:click="checkParty">Get</button>
            </div>
          </div>

        </div>
        <div class="form-group">
          <label for="un1">Code</label>
          <input type="text" class="form-control"
                 id="un1"
                 v-model="c.code">

        </div>
        <div class="form-group">
          <label for="un">Name</label>
          <input type="text" class="form-control"
                 id="un"
                 v-model="c.name">

        </div>
        <div class="form-group">
          <label for="pwd">Address</label>
          <input type="text" class="form-control"
                 id="pwd"
                 v-model="c.address">

        </div>
        <div class="form-group">
          <label for="pin">PinCode</label>
          <input type="text" class="form-control"
                 id="pin"
                 v-model="c.pincode">

        </div>

        <button type="button" v-on:click="saveParty()" class="btn btn-primary">
          <i class="fa fa-save"></i> Save
        </button>

      </form>
    </div>
    <div class="col-9">
      <h4 class="form-head">
        Existing Customers
      </h4>
      <table class="table table-borderless">
        <thead class="thead-dark">
        <tr>
          <th>GST Number</th>
          <th>Name</th>
          <th>Address</th>
          <th>State</th>
          <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="u of parties" :key="u.id">
          <td>{{u.gstin}}</td>
          <td>{{u.name}}</td>
          <td>{{u.address}}</td>
          <td>{{u.state}}</td>
          <td>
            <button class="btn btn-secondary btn-sm" v-on:click="editConsignee(u)" v-b-tooltip.hover title="Delete Customer">
              <i class="fa fa-pencil"></i>
            </button>
          </td>

        </tr>
        </tbody>
      </table>

    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
let apiUrl = `/app/party?type=CONSIGNEE`
let apiDeleteUrl = `/app/party/delete?type=CONSIGNEE`

export default {
  name: 'ConsigneePage',
  created: function () {
    this.$store.dispatch('isLoggedIn').then(() => {
      if (!this.$store.state.loggedIn) {
        console.log('Not Logged-in')
        this.$router.push('login')
      }
      this.loadConsignee()
    }, _ => {
      console.error('isLoggedIn Failed, lets go to login')
      this.$router.push('login')
    })
  },
  data () {
    return {
      c: {
        gstin: '',
        name: '',
        address: '',
        state: '',
        pincode: '',
        appPartyType: 'CONSIGNEE'
      },
      parties: []
    }
  },
  methods: {
    loadConsignee: function () {
      axios.get(apiUrl)
        .then(response => {
          this.parties = response.data
        }, error => {
          console.error('Error in Loading Party', error)
        })
    },
    editConsignee: function (e) {
      this.c = Object.assign({}, e)
    },
    saveParty: function () {
      axios.post(apiUrl, this.c)
        .then(response => {
          this.c = {
            gstin: '',
            name: '',
            state: '',
            address: '',
            pincode: '',
            appPartyType: 'CONSIGNEE'
          }
          this.loadConsignee()
        }, error => {
          console.error('Error in Loading Party', error)
        })
    },
    checkParty: function () {
      let g = this.c.gstin
      if (g.length === 15) {
        axios.get(`https://api.e-waybill.in/api/gstin/validate?gstin=${g}`)
          .then(response => {
            let dealer = response.data
            if (dealer.valid) {
              this.c.name = dealer.name
              this.c.address = dealer.address
              this.c.state = dealer.state
              this.c.pincode = dealer.pinCode
              console.log('C = ', this.c)
            } else {
              alert('Invalid GSTIN, Check Again')
            }
          }, error => {
            console.error('Error in gstin', error)
          })
      } else {
        console.log(`Ignore ${g}`)
      }
    },
    deleteParty: function (u) {
      axios.post(`${apiDeleteUrl}&id=${u.id}`)
        .then(response => {
          this.loadConsignee()
        }, error => {
          console.error('Error in delete Party', error)
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/ConsigneePage.vue